import About from '../about/About';
import './AboutUs.css';
const Aboutus = () => {

  return (
    <section class="about-section">
      <h2 class="about-title" data-aos="fade-right">About Al Muntazar TV</h2>

      <div class="info-box about-content">
        <div class="about-text" data-aos="fade-up" data-aos-delay="100">
          <h4>Courtesy – Association of Imam Mahdi (a.s.):</h4>

          <h5>History</h5>
          <p>
            The foundation of <strong>Association of Imam Mahdi (a.s.)</strong>, Mumbai (India) was laid by
            <strong>Respected Hujjatul Islam Maulana Shaikh Muhammad Ismail Rajabi Saahab (r.a.)</strong> – a
            learned, pious and noble scholar.
          </p>

          <p>
            A few, who were in his company, began to share his concerns and a desire for serving Islam and the
            followers of Ahle Bait (a.s.) blossomed in their hearts. These select few were as follows:
            <strong>Maulana Sayed Ghulam Hasnain Rizvi Karaarvi (r.a.)</strong>,
            <strong>Sayed Muhammad Akbar Rizvi</strong> and <strong>Janab Haiderbhai Nayani</strong>.
          </p>

          <p>
            It was in 1977 when the respected Maulana Saahab (r.a.) advised them to initiate religious teaching
            and training activity for the youth and the religiously inclined intelligentsia of the Shiite
            society. He explained the method for conducting this training. This paved the way for the first class
            of Association of Imam Mahdi (a.s.). It was conducted at the house of Maulana Saahab (r.a.) and
            <strong>Maulana Ghulam Hasnain Rizvi (r.a.)</strong> was its teacher who conducted the class in the
            presence of Maulana Saahab (r.a.).
          </p>

          <p>
            Gradually, more people – especially the youth – began joining such classes. Thus, the group of
            knowledge-seekers associated with Imam-e-Zamana (a.t.f.s.) increased by the day.
          </p>

          <div class="video-section" data-aos="zoom-in">
            <h5>Watch our Journey in Video:</h5>
            <About />
          </div>

          <h5>Our Activities</h5>
          <p>
            Association of Imam Mahdi (a.s.) is primarily into propagation of religion. Our channels of
            propagation are:
          </p>

          <ul class="activities-list">
            <li>
              <strong>Website:</strong>
              <a href="https://www.almuntazar.tv" target="_blank">www.almuntazar.tv</a> – Al Muntazar TV is a
              YouTube channel with various Islamic content in Urdu like Speeches & Taqreer, Ashaar, Islamic
              Tamseel / Films, Children Tamseel / Animation Films, Surood / Manqabat, etc.
            </li>
            <li>
              <strong>Website:</strong>
              <a href="https://www.almuntazar.com" target="_blank">www.almuntazar.com</a> – Our recent endeavour
              to reach to a wider audience was initiated some time back. Through this website we share articles,
              books written on lesser known topics and other media of Islamic propagation.
            </li>
            <li>
              <strong>Al-Muntazar Magazine:</strong> Published twice a year. To subscribe (only in India), write
              to us on WhatsApp at +91 9987777757 with your full name, address, and preferred language.
            </li>
            <li>Weekly Religious Classes at various locations for both genders.</li>
            <li>
              <strong>Majaalis/Programs:</strong> Regular Majaalis in Moharram al-Haraam, 15th Shabaan functions,
              Eid-e-Ghadeer celebrations, and Book Exhibitions.
            </li>
            <li>
              <strong>Correspondence Course:</strong> For places where physical propagation is not possible.
            </li>
          </ul>
        </div>
      </div>
      <div class="info-box contact-info" data-aos="fade-left" data-aos-delay="200">
        <h2>Contact Us</h2>
        <h3><strong>Email:</strong> <a href="mailto:almuntazartv@gmail.com">almuntazartv@gmail.com</a></h3>
        <h3><strong>WhatsApp:</strong> <a href="https://wa.me/919372809411">+91 9372809411</a></h3>
      </div>
    </section>



  );
}
export default Aboutus;